import Vue from "vue";
import App from "./App.vue";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import animated from "animate.css"; // npm install animate.css --save安装，再引入
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router/index.js";
// import "../node_modules/timeline-vuejs/dist/timeline-vuejs.css";
Vue.use(ElementUI);
Vue.use(animated);
Vue.config.productionTip = false;
Vue.use(Antd);
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
